import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppConfig, SystemHeader } from '../service/DTOs';
import * as TF from '../service/tradeflow';
import * as DTO from '../service/DTOs';
import * as API from '../service/apisvc';
import * as RB from 'react-bootstrap';
import * as Actions from '../service/Actions';
import * as Dispatch from '../service/Dispatcher';
import { MatrixFormFilter, initialstate_matrixfilter } from './view/MatrixFormFilter'
import { SecurityRecord, initialstate_secrecord } from './view/filterrecords/SecurityRecord'
import { EntityRecord, initialstate_entityrecord } from './view/filterrecords/EntityRecord'



import 'isomorphic-fetch';

import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { SecurityListItem, EntityListItem } from './view/LookupListItems';


type FilterSettingsProps = FilterSettingsState & { xsrfToken?: string } & { filterDS: DTO.AgentDSInstrumentFilter } & RouteComponentProps<{}>;
//type SettingsProps = SettingsState & { xsrfToken?: string } & RouteComponentProps<{}>;

interface FilterSettingsState {
    //iheader: DTO.InstrumentHead;
    loading?: boolean;
}

export class FilterSettings extends React.Component<FilterSettingsProps, FilterSettingsState> {
    secFilter: MatrixFormFilter<DTO.Security> | null = null;
    caFilter: MatrixFormFilter<DTO.EntityDto> | null = null;
    constructor(props: FilterSettingsProps) {
        super(props);

        if (props)
            this.state = { loading: props.loading };
    }


    handleSelectContextSec(locatorId?: string, record?: DTO.Security) {
        if (this.secFilter)
            this.secFilter.handleSelectContext(locatorId, record);
    }

    handleRemoveSec(locatorId?: string, record?: DTO.Security) {
        if (this.secFilter)
            this.secFilter.handleRemove(locatorId, record);
    }


    handleSelectContextCa(locatorId?: string, record?: DTO.EntityDto) {
        if (this.caFilter)
            this.caFilter.handleSelectContext(locatorId, record);
    }

    handleRemoveCa(locatorId?: string, record?: DTO.EntityDto) {
        if (this.caFilter)
            this.caFilter.handleRemove(locatorId, record);
    }

    dispatchSecFilterSettings = (action: Actions.FilterSettingsAction) => {
        if (action.type == 'RESET_FILTERSETTINGS_MODIFICATION_FORM') {
            if (this.secFilter) {
                this.secFilter.typeahead.getInstance().clear();                
            }
        }

        if (this.secFilter) {
            return Dispatch.FilterSettingsDispatcher(this.secFilter, action);
        }
        
        return {};
    }

    dispatchCaFilterSettings = (action: Actions.FilterSettingsAction) => {
        if (action.type == 'RESET_FILTERSETTINGS_MODIFICATION_FORM') {
            if (this.caFilter) {
                this.caFilter.typeahead.getInstance().clear();
            }
        }

        if (this.caFilter) {
            return Dispatch.FilterSettingsDispatcher(this.caFilter, action);
        }

        return {};
    }
    processAppendSec(sec: DTO.Security) {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_FILTER_INCLUDE,
            locatorId: '' + sec.id,
            payload: undefined
        }

        return Actions.secFilterActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchSecFilterSettings);
    }

    processAppendCA(entity: DTO.EntityDto) {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_FILTER_INCLUDE,
            locatorId: '' + entity.id,
            payload: undefined
        }

        return Actions.caFilterActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    }

    processRemoveSec(sec: DTO.Security) {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_FILTER_EXCLUDE,
            locatorId: '' + sec.id,
            payload: undefined
        }

        return Actions.secFilterActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchSecFilterSettings);
    }

    processRemoveCA(entity: DTO.EntityDto) {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_FILTER_EXCLUDE,
            locatorId: '' + entity.id,
            payload: undefined
        }

        return Actions.caFilterActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    }
    

    loadFilterStateSec(): Promise<DTO.Security[]> {
        let _that = this;
        return new Promise(function (resolve, reject) {
            fetch(API.apiUrl(API.API_SECFILTER_URL), {
                method: 'GET',
                credentials: 'include',
                headers: new Headers({
                    ...{ 'X-XSRF-TOKEN': _that.props.xsrfToken || '' },
                    ...API.authHeader()
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json() as Promise<DTO.Security[]>
                    } else {
                        var error = new Error(response.statusText);
                        throw error;
                    }
                }
                )
                .then(data => {
                    return resolve(data);
                })
                .catch(reason => {
                    console.log(reason);
                    reject(reason);
                });
        });
    }

    loadFilterStateCA(): Promise<DTO.EntityDto[]> {
        let _that = this;
        return new Promise(function (resolve, reject) {
            fetch(API.apiUrl(API.API_CAFILTER_URL), {
                method: 'GET',
                credentials: 'include',
                headers: new Headers({
                    ...{ 'X-XSRF-TOKEN': _that.props.xsrfToken || '' },
                    ...API.authHeader()
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json() as Promise<DTO.EntityDto[]>
                    } else {
                        var error = new Error(response.statusText);
                        throw error;
                    }
                }
                )
                .then(data => {
                    return resolve(data);
                })
                .catch(reason => {
                    console.log(reason);
                    reject(reason);
                });
        });
    }

    renderElementCa(data: DTO.EntityDto, idx: number) {

        return <EntityListItem key={'elemlistitem_' + idx} entity={data} />
    };

    renderElementSec(data: DTO.Security, idx: number) {

        return <SecurityListItem key={'elemlistitem_' + idx} sec={data} />
    }

    getOptionsSec = (query: string) => {

        return fetch(API.apiUrl(API.API_SECLOOKUP_URL) + "/" + `${query}` + ".json", {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                ...
                {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': this.props.xsrfToken || ''
                },
                ...API.authHeader()
            })
        })
            .then((response) => {
                return response.json();
            }).then((json) => {
                return { options: json };
            });
    }

    getOptionsCa = (query: string) => {
        return fetch(API.apiUrl(API.API_ENTITYLOOKUP_URL) + "/" + `${query}` + ".json", {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                ...
                {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': this.props.xsrfToken || ''
                },
                ...API.authHeader()
            })
        })
            .then((response) => {
                return response.json();
            }).then((json) => {
                return { options: json };
            });
    }


    renderFilterTableSec(records: DTO.Security[], processing: boolean, rowRenderer: (data: DTO.Security, selected_locatorId?: string) => JSX.Element, selected_locatorId?: string) {
                //{records.map(domrecord =>
                //    <DoMRecordRecord key={domrecord.manipulation.locatorId} record={domrecord} xsrfToken={this.props.xsrfToken} {...initialstate_domrecord} modified={domrecord.manipulation.justChanged ? domrecord.manipulation.justChanged : false}
                //        processing={processing} domrecordSelected={this.handleSelectContext.bind(this)} selected={this.state.selected_locatorId == domrecord.manipulation.locatorId} holdFocus={this.state.holdFocus} />
                //)}

        return <table className='table table-header-fixed table-fix-H-200 table-condensed'>
            <thead>
                <tr style={{ width: 'calc(100% - 10px)' }}>
                    <th style={{ textAlign: 'right', width: '30%' }}>Тикер</th>
                    <th style={{ textAlign: 'right', width: '20%' }}>ISIN</th>
                    <th style={{ textAlign: 'right', width: '50%' }}>Название</th>
                </tr>
            </thead>
            <tbody style={{ height: '145px' }}>
                {records.map(sec =>
                    rowRenderer(sec, selected_locatorId)
                )}                

            </tbody>
        </table>;
    }


    renderFilterTableCa(records: DTO.EntityDto[], processing: boolean, rowRenderer: (data: DTO.EntityDto, selected_locatorId?: string) => JSX.Element, selected_locatorId?: string) {
        return <table className='table table-header-fixed table-fix-H-200 table-condensed'>
            <thead>
                <tr style={{ width: 'calc(100% - 10px)' }}>
                    <th style={{ textAlign: 'right', width: '30%' }}>Reuter Code</th>
                    <th style={{ textAlign: 'right', width: '20%' }}>Краткое название</th>
                    <th style={{ textAlign: 'right', width: '50%' }}>Полное название</th>
                </tr>
            </thead>
            <tbody style={{ height: '145px' }}>
                {records.map(sec =>
                    rowRenderer(sec, selected_locatorId)
                )}

            </tbody>
        </table>;
    }
    public render() {
        //let FilterSec: new () => MatrixFormFilter<DTO.Security> = C;

        //const MatrixSecurityFilter = MatrixFormFilter as MatrixSecurityFilter;
        const MatrixContragentFilter = MatrixFormFilter as MatrixContragentFilter;

        //let contentsFilterSec = this.state.loading
        //    ? <p><em>Processing...</em></p>
        //    : <MatrixSecurityFilter ref={(secFilter) => this.secFilter = secFilter} key={'MatrixSecurityFilter'}
        //        titleOfElem={"Ценная бумага"} titlePlural={'бумаги'} isLoading={this.state.loading} xsrfToken={this.props.xsrfToken} {...initialstate_matrixfilter} 
        //        processAppend={this.processAppendSec.bind(this)} processRemove={this.processRemoveSec.bind(this)}
        //        loadFilterState={this.loadFilterStateSec.bind(this)}
        //        getOptions={this.getOptionsSec.bind(this)}
        //        renderFilterTableRow={(sec, selected_locatorId?: string) => (
        //            <SecurityRecord key={'sec_item_' + sec.id} record={sec} xsrfToken={this.props.xsrfToken} {...initialstate_secrecord}
        //                processing={this.secFilter ? this.secFilter.state.processing : false}
        //                secSelected={this.handleSelectContextSec.bind(this)}
        //                secRemove={this.handleRemoveSec.bind(this)}
        //                selected={selected_locatorId ? selected_locatorId == '' + sec.id : false}
        //                 />
        //            )}

        //            lookupFilterBy={['isin', 'name', 'secid', 'shortname']}
        //            llokupLabelKey={'secid'}
        //            renderLookupMenuItemChildren={(sec, props, idx) => (
        //                <SecurityListItem key={'elemlistitem_' + idx} sec={sec} />
        //            )}
        //            renderElement = { this.renderElementSec.bind(this) }
        //            renderFilterTable = { this.renderFilterTableSec.bind(this) }
        //        />;

        let contentsFilterCA = this.state.loading
            ? <p><em>Processing...</em></p>
            : <MatrixContragentFilter ref={(caFilter) => this.caFilter = caFilter} key={'MatrixContragentFilter'}
                titleOfElem={"Контрагент"} titlePlural={'Избранные контрагенты'} isLoading={this.state.loading} xsrfToken={this.props.xsrfToken} {...initialstate_matrixfilter}
                processAppend={this.processAppendCA.bind(this)} processRemove={this.processRemoveCA.bind(this)}
                loadFilterState={this.loadFilterStateCA.bind(this)}
                getOptions={this.getOptionsCa.bind(this)}
                renderFilterTableRow={(entity, selected_locatorId?: string) => (
                    <EntityRecord key={'ca_item_' + entity.id} record={entity} xsrfToken={this.props.xsrfToken} {...initialstate_entityrecord}
                        processing={this.caFilter ? this.caFilter.state.processing : false}
                        entitySelected={this.handleSelectContextCa.bind(this)}
                        entityRemove={this.handleRemoveCa.bind(this)}
                        selected={selected_locatorId ? selected_locatorId == '' + entity.id : false}
                    />
                )}

                lookupFilterBy={['fullname', 'shortname', 'reutercode', 'addresslegal']}
                llokupLabelKey={'shortname'}
                renderLookupMenuItemChildren={(entity, props, idx) => (
                    <EntityListItem key={'elemlistitem_' + idx} entity={entity} />
                )}
                renderElement={this.renderElementCa.bind(this)}
                renderFilterTable={this.renderFilterTableCa.bind(this)}
            />;

        // style={{ minHeight: '380px', margin: '0px 2px 0px 2px' }}
        return <div ref="settingsRef" className="otc-trade">
            <RB.Row>
                <RB.Col sm={12}>
                    {/*
                    <RB.Well bsSize="sm" className='otc-filter-panel'>
                        <div>
                            <div style={{ fontSize: '14' }}><b>{'Лимитный фильтр ценных бумаг'}</b></div>
                        </div>
                        <div>{contentsFilterSec}</div>
                    </RB.Well>
                    */}

                    <RB.Well bsSize="sm" className='otc-filter-panel'>
                        <div>
                            <div style={{ fontSize: '14px' }}><b>{'Мои контрагенты'}</b></div>
                        </div>
                        <div>{contentsFilterCA}</div>
                    </RB.Well>

                </RB.Col>
            </RB.Row>

        </div>;
    }
}






type MatrixSecurityFilter = new () => MatrixFormFilter<DTO.Security>;
type MatrixContragentFilter = new () => MatrixFormFilter<DTO.EntityDto>;


